import { create } from "zustand";
import type { ReactNode } from "react";

interface TitleStore {
    title: ReactNode;
    setTitle: (title: ReactNode) => void;
}

interface ActionsStore {
    actions: ReactNode;
    setActions: (actions: ReactNode) => void;
}

export const useTitleStore = create<TitleStore>((set) => ({
    title: "  ",
    setTitle: (title) => set({ title }),
}));

export const useActionsStore = create<ActionsStore>((set) => ({
    actions: null,
    setActions: (actions) => set({ actions }),
}));